import React from 'react'

const Kitscard = (props) => {
    return (
        <>
                <div className='kits_card' style={{ width: props.width, height: props.height }}>
                    <img className='card_img' src={props.image} alt='kits_img' />
                    <div className='button_div'><button className='download_button'>{props.btnname}</button></div>
                </div>
        </>
    )
}

export default Kitscard
